<template>
  <div class="layout">
    <div class="wrapper">
      <div class="lang-ko">
        <div class="weight--wrap">
          <p class="weight-400">weight-400 : 비밀번호는 6자 이상이어야 합니다.</p>
          <p class="weight-500">weight-500 : 비밀번호는 6자 이상이어야 합니다.</p>
          <p class="weight-600">weight-600 : 비밀번호는 6자 이상이어야 합니다.</p>
          <p class="weight-700">weight-700 : 비밀번호는 6자 이상이어야 합니다.</p>
          <p class="weight-bold">weight-bold : 비밀번호는 6자 이상이어야 합니다.</p>
        </div>

        <div>
          <p>1. size small / no icon</p>
          <ui-button primary size="small">페이지 등록</ui-button>
          <ui-button primary2 size="small">페이지 등록</ui-button>
          <ui-button primary3 size="small">페이지 등록</ui-button>

          <p>1-2. size small / use icon</p>
          <ui-button primary size="small" iconName="icon--pencil">페이지 등록</ui-button>
          <ui-button primary2 size="small" iconName="icon--pencil">페이지 등록</ui-button>
          <ui-button primary3 size="small" iconName="icon--pencil">페이지 등록</ui-button>

          <p>2. size normal / no icon</p>
          <ui-button primary>페이지 등록</ui-button>
          <ui-button primary2>페이지 등록</ui-button>
          <ui-button primary3>페이지 등록</ui-button>

          <p>2-2. size normal / use icon</p>
          <ui-button primary iconName="icon--pencil">페이지 등록</ui-button>
          <ui-button primary2 iconName="icon--pencil">페이지 등록</ui-button>
          <ui-button primary3 iconName="icon--pencil">페이지 등록</ui-button>

          <p>3. size large / no icon</p>
          <ui-button primary size="large">페이지 등록</ui-button>
          <ui-button primary2 size="large">페이지 등록</ui-button>
          <ui-button primary3 size="large">페이지 등록</ui-button>

          <p>3-2. size large / use icon</p>
          <ui-button primary size="large" iconName="icon--pencil">페이지 등록</ui-button>
          <ui-button primary2 size="large" iconName="icon--pencil">페이지 등록</ui-button>
          <ui-button primary3 size="large" iconName="icon--pencil">페이지 등록</ui-button>
        </div>

        <hr>

        <div class="family--wrap">
          font1({{ font1 }}) : <ui-button primary iconName="icon--pencil" :style="{ 'font-family': font1 }">페이지 등록</ui-button><br>
          font2({{ font2 }}) : <ui-button primary2 iconName="icon--pencil" :style="{ 'font-family': font2 }">페이지 등록</ui-button><br>
          font3({{ font3 }}) : <ui-button primary3 iconName="icon--pencil" :style="{ 'font-family': font3 }">페이지 등록</ui-button>
        </div>
      </div>

      <div class="lang-en">
        <div class="weight--wrap">
          <p class="weight-400">weight-400 : Please enter a minimum of 6 characters.</p>
          <p class="weight-500">weight-500 : Please enter a minimum of 6 characters.</p>
          <p class="weight-600">weight-600 : Please enter a minimum of 6 characters.</p>
          <p class="weight-700">weight-700 : Please enter a minimum of 6 characters.</p>
          <p class="weight-bold">weight-bold : Please enter a minimum of 6 characters.</p>
        </div>

        <div>
          <p>1. size small / no icon</p>
          <ui-button primary size="small">Register Page</ui-button>
          <ui-button primary2 size="small">Register Page</ui-button>
          <ui-button primary3 size="small">Register Page</ui-button>

          <p>1-2. size small / use icon</p>
          <ui-button primary size="small" iconName="icon--pencil">Register Page</ui-button>
          <ui-button primary2 size="small" iconName="icon--pencil">Register Page</ui-button>
          <ui-button primary3 size="small" iconName="icon--pencil">Register Page</ui-button>

          <p>2. size normal / no icon</p>
          <ui-button primary>Register Page</ui-button>
          <ui-button primary2>Register Page</ui-button>
          <ui-button primary3>Register Page</ui-button>

          <p>2-2. size normal / use icon</p>
          <ui-button primary iconName="icon--pencil">Register Page</ui-button>
          <ui-button primary2 iconName="icon--pencil">Register Page</ui-button>
          <ui-button primary3 iconName="icon--pencil">Register Page</ui-button>

          <p>3. size large / no icon</p>
          <ui-button primary size="large">Register Page</ui-button>
          <ui-button primary2 size="large">Register Page</ui-button>
          <ui-button primary3 size="large">Register Page</ui-button>

          <p>3-2. size large / use icon</p>
          <ui-button primary size="large" iconName="icon--pencil">Register Page</ui-button>
          <ui-button primary2 size="large" iconName="icon--pencil">Register Page</ui-button>
          <ui-button primary3 size="large" iconName="icon--pencil">Register Page</ui-button>
        </div>

        <hr>

        <div class="family--wrap">
          font1({{ font1 }}) : <ui-button primary iconName="icon--pencil" :style="{ 'font-family': font1 }">Register Page</ui-button><br>
          font2({{ font2 }}) : <ui-button primary2 iconName="icon--pencil" :style="{ 'font-family': font2 }">Register Page</ui-button><br>
          font3({{ font3 }}) : <ui-button primary3 iconName="icon--pencil" :style="{ 'font-family': font3 }">Register Page</ui-button>
        </div>
      </div>

      <div class="lang-ja">
        <div class="weight--wrap">
          <p class="weight-400">weight-400 : パスワードは6文字以上にする必要があります。</p>
          <p class="weight-500">weight-500 : パスワードは6文字以上にする必要があります。</p>
          <p class="weight-600">weight-600 : パスワードは6文字以上にする必要があります。</p>
          <p class="weight-700">weight-700 : パスワードは6文字以上にする必要があります。</p>
          <p class="weight-bold">weight-bold : パスワードは6文字以上にする必要があります。</p>
        </div>

        <div>
          <p>1. size small / no icon</p>
          <ui-button primary size="small">ページ登録</ui-button>
          <ui-button primary2 size="small">ページ登録</ui-button>
          <ui-button primary3 size="small">ページ登録</ui-button>

          <p>1-2. size small / use icon</p>
          <ui-button primary size="small" iconName="icon--pencil">ページ登録</ui-button>
          <ui-button primary2 size="small" iconName="icon--pencil">ページ登録</ui-button>
          <ui-button primary3 size="small" iconName="icon--pencil">ページ登録</ui-button>

          <p>2. size normal / no icon</p>
          <ui-button primary>ページ登録</ui-button>
          <ui-button primary2>ページ登録</ui-button>
          <ui-button primary3>ページ登録</ui-button>

          <p>2-2. size normal / use icon</p>
          <ui-button primary iconName="icon--pencil">ページ登録</ui-button>
          <ui-button primary2 iconName="icon--pencil">ページ登録</ui-button>
          <ui-button primary3 iconName="icon--pencil">ページ登録</ui-button>

          <p>3. size large / no icon</p>
          <ui-button primary size="large">ページ登録</ui-button>
          <ui-button primary2 size="large">ページ登録</ui-button>
          <ui-button primary3 size="large">ページ登録</ui-button>

          <p>3-2. size large / use icon</p>
          <ui-button primary size="large" iconName="icon--pencil">ページ登録</ui-button>
          <ui-button primary2 size="large" iconName="icon--pencil">ページ登録</ui-button>
          <ui-button primary3 size="large" iconName="icon--pencil">ページ登録</ui-button>
        </div>

        <hr>

        <div class="family--wrap">
          font1({{ font1 }}) : <ui-button primary iconName="icon--pencil" :style="{ 'font-family': font1 }">ページ登録</ui-button><br>
          font2({{ font2 }}) : <ui-button primary2 iconName="icon--pencil" :style="{ 'font-family': font2 }">ページ登録</ui-button><br>
          font3({{ font3 }}) : <ui-button primary3 iconName="icon--pencil" :style="{ 'font-family': font3 }">ページ登録</ui-button>
        </div>
      </div>
    </div>

    font1: <input type="text" v-model="font1">
    font2: <input type="text" v-model="font2">
    font3: <input type="text" v-model="font3">
  </div>
</template>

<script>
import UiButton from '@/components/ui/UiButton'

export default {
  components: {
    UiButton
  },
  data () {
    return {
      font1: '',
      font2: '',
      font3: ''
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
.layout {
  width: 100%;
  height: 100%;
  background-color: white;
  padding: 40px;
  box-sizing: border-box;
  overflow: auto;
}
.wrapper {
  display: flex;
  justify-content: space-between;
  min-width: 1280px;
  margin-bottom: 40px;

  hr {
    margin: 10px 0;
  }

  & > div {
    width: 33%;
    border: 1px solid #000;
    padding: 10px;
    box-sizing: border-box;

    p {
      margin-top: 10px;
      margin-bottom: 10px;
    }
  }

  .weight-400 {
    font-weight: 400;
  }
  .weight-500 {
    font-weight: 500;
  }
  .weight-600 {
    font-weight: 600;
  }
  .weight-700 {
    font-weight: 700;
  }
  .weight-bold {
    font-weight: bold;
  }

  .weight--wrap,
  .family--wrap {
    font-size: 13px;
  }

  .family--wrap {
    .ui-btn {
      margin-bottom: 15px;
    }
  }
}
</style>
